"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CustomTextInput = function CustomTextInputRenderer(_ref) {
  var storedValue = _ref.storedValue,
      isValid = _ref.isValid,
      complete = _ref.complete,
      fieldData = _ref.fieldData,
      eventHandler = _ref.eventHandler,
      isFocused = _ref.isFocused,
      updateValue = _ref.updateValue,
      updatedValue = _ref.updatedValue;
  (0, _react.useEffect)(function () {
    if (typeof updatedValue === 'string') {
      eventHandler.onUpdate(updatedValue);
    }
  }, [updatedValue]);
  (0, _react.useEffect)(function () {
    if (storedValue && updatedValue) {
      updateValue(null);
    }
  }, [storedValue]);
  var isLockedValue = fieldData.options.length === 1;
  var inputProps = {
    id: fieldData.id,
    name: fieldData.fieldKey,
    autoComplete: fieldData.autocomplete
  };

  var wrapperClasses = function wrapperClasses() {
    return (0, _classnames["default"])({
      'text-input-control__wrapper': true,
      'text-input-control__wrapper--focused': isFocused,
      'text-input-control__wrapper--error': complete && !isValid,
      'text-input-control__wrapper--valid': complete && isValid
    });
  };

  var hiddenInput = function hiddenInput() {
    if (!isLockedValue) {
      return null;
    }

    return /*#__PURE__*/_react["default"].createElement("input", _extends({
      name: fieldData.fieldKey,
      type: "hidden",
      value: fieldData.options[0].value
    }, inputProps));
  };

  var visibleInputProps;
  var visibleValue;

  if (isLockedValue) {
    visibleInputProps = {
      id: "".concat(fieldData.id, "-readonly")
    };
    visibleValue = fieldData.options[0].label;
  } else {
    visibleInputProps = inputProps;
    visibleValue = storedValue;
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, fieldData.instructions && /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-input-control__instructions"
  }, fieldData.instructions), /*#__PURE__*/_react["default"].createElement("div", {
    className: wrapperClasses()
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: visibleInputProps.id,
    className: "text-input-control__label"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-input-control__label-text"
  }, fieldData.label)), hiddenInput(), /*#__PURE__*/_react["default"].createElement("input", _extends({
    className: "text-input-control__input",
    type: fieldData.control.type,
    value: visibleValue,
    onChange: function onChange(event) {
      return eventHandler.onChange(event);
    },
    onBlur: function onBlur(event) {
      return eventHandler.onBlur(event);
    },
    onFocus: function onFocus() {
      return eventHandler.onFocus();
    },
    "aria-describedby": fieldData.ariaDescribedBy || "".concat(fieldData.id, "-error"),
    required: fieldData.validation.required,
    readOnly: isLockedValue
  }, visibleInputProps)), /*#__PURE__*/_react["default"].createElement("div", {
    id: "".concat(fieldData.id, "-error"),
    role: "alert",
    "aria-live": "assertive"
  }, !isValid && complete && /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-input-control__error"
  }, fieldData.validation.message))));
};

CustomTextInput.propTypes = {
  storedValue: _propTypes["default"].string.isRequired,
  isValid: _propTypes["default"].bool.isRequired,
  complete: _propTypes["default"].bool.isRequired,
  isFocused: _propTypes["default"].bool.isRequired,
  eventHandler: _propTypes["default"].shape({
    onChange: _propTypes["default"].func.isRequired,
    onBlur: _propTypes["default"].func.isRequired,
    onFocus: _propTypes["default"].func.isRequired,
    onUpdate: _propTypes["default"].func.isRequired
  }).isRequired,
  fieldData: _propTypes["default"].shape({
    ariaDescribedBy: _propTypes["default"].string,
    id: _propTypes["default"].string.isRequired,
    fieldKey: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string.isRequired,
    options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      label: _propTypes["default"].string.isRequired,
      value: _propTypes["default"].string.isRequired
    })).isRequired,
    validation: _propTypes["default"].shape({
      message: _propTypes["default"].string.isRequired,
      pattern: _propTypes["default"].string.isRequired,
      required: _propTypes["default"].bool
    }).isRequired,
    value: _propTypes["default"].string.isRequired,
    autocomplete: _propTypes["default"].string.isRequired,
    instructions: _propTypes["default"].string,
    control: _propTypes["default"].shape({
      type: _propTypes["default"].string
    })
  }).isRequired,
  updateValue: _propTypes["default"].func,
  updatedValue: _propTypes["default"].string
};
CustomTextInput.defaultProps = {
  updateValue: null,
  updatedValue: null
};
var _default = CustomTextInput;
exports["default"] = _default;